import {ApiService} from "./ApiService";

export const CommonApi = {

    regionChildrenLimit(limitLevel) {
        return ApiService.get("/api/v1/region/children/limit", {limitLevel: limitLevel})
    }

}